import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeComponentProps as _mergeComponentProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("styled-pill-button__styledpillbuttonstyles-29xauc", {
  display: "inline-block",
  transition: "0.2s",
  whiteSpace: "nowrap",
  textDecoration: "underline",
  textDecorationThickness: "1px",
  textUnderlineOffset: "2px",
  padding: "4px 8px",
  fontWeight: "500",
  borderRadius: "3px",
  "&:hover": {
    backgroundColor: "var(--system-grey-100)"
  },
  "&:active": {
    backgroundColor: "var(--system-grey-200)"
  },
  "@media (max-width: 1200px)": {
    padding: "0",
    "&:hover": {
      backgroundColor: "transparent"
    },
    "&:active": {
      backgroundColor: "transparent"
    }
  }
});
import React from 'react';
import Link, { LinkProps } from '../link';
import Button, { ButtonProps } from '../button';
import { colors } from '../colors';
import { borderRadius, breakpoints } from '../tokens';
export const styledPillButtonStyles = _staticStyles;
const StyledPillButton = React.forwardRef<HTMLButtonElement, ButtonProps>(({
  ...props
}, ref) => <Button {..._mergeComponentProps({
  ref: ref,
  css: styledPillButtonStyles
}, props)} />);
StyledPillButton.displayName = 'StyledPillButton';
export const StyledPillButtonAsLink = React.forwardRef<HTMLAnchorElement, LinkProps>(({
  ...props
}, ref) => <Link {..._mergeComponentProps({
  ref: ref,
  css: styledPillButtonStyles
}, props)} />);
StyledPillButtonAsLink.displayName = 'StyledPillButtonAsLink';
export default StyledPillButton;